import React from 'react';
import { Cart } from '../../../common/models/cart';
import { PaymentResponse } from '../../../common/models/mesh-paymentresponse';
import { GetPaymentStatusResponse } from '../../../common/models/payment_status';

export interface IAppContext {
    cart: Cart | undefined;
    cartID: string | undefined;
    paymentProgress: GetPaymentStatusResponse | undefined;
    order: PaymentResponse | undefined;
    state: "buying" | "paying" | "finished";
    error: string | undefined,
    contactID?: string,
    isPaying: boolean,
    transferSuccessful: boolean,
    updateCart(id: string): void;
    startPayment(id: string): void;
    completePayment(): void;
    updatePaymentProgress(): Promise<void>;
    resetPayment(): void;
}

const AppContext = React.createContext<IAppContext>({} as any)

export default AppContext;